import services from './../../services/service'; // Service Class
import validator from './../../services/validator'; // Validator
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import HorizontalWidget from '../HorizontalWidget.vue'; // HorizontalWidget
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; //Search Bar
// import jsonp from 'jsonp'

let service = new services();
let valid = new validator();

export default {
    name: 'CNpay',
    data () {
        return {
            user: {},
            user_details:{},
            rrr:{},
            rrr_details:{},
            rrr_txn_details:{},
            panelFlag: false,
            addFlag: false,
            backgroundSize: 'contain',
            disable_btn: false,
            error_count: 0,
            request_sent: false,
            show_code_details: false,
            rrr_err_message: "",
            onboarding: false,
            loading: false,
            rloading:false,
            processing:false,
            cnpay_proc_fee: 0, // cnpay proce fee with ravepay_commision
            cnpay_proc_fee: 0, //cnpay dynamic charge
            cnpay_post_txn_id: 0,
            cnpay_post_txn_ref: "",
            range_1_max: 5000,
            range_2_max: 10000,
            range_1_pay: 25,
            range_2_pay: 50,
            range_3_pay: 100,
            ravecomm:0.0, //(1.4 / 100),
            total_fee:0,
            payment_message: "",
            payment_service_message:"",
            login_script: false,
            loggedIn: false,
            disable_btn_login:false,
            disable_btn_wallet:false,
            paga_service_groups:{},
            paga_merchant:{},
            paga_airtime_request:{},
            paga_bundle_request:{},
            show_paga_service_details: false,
            show_airtime_form_details: false,
            show_data_bundle:false,
            show_data_bundle_phone_number_field:false,
            is_paga_merchant_purchase:false,
            is_paga_mobileops_purchase:false,
            serviceToPayFor:{},
            customer:{},
            customer_received_details:{},
            data_error_message:"",
            data_phone_error_message:"",
            data_email_error_message:"",
            setPayWithOption:false,
            today: new Date(),
            img_url: service.imageURL,
            serviceToPayComponentKey:1,

            //walllet calls
            payment_details:{},
            wallet_charges:{},
            wallet_transaction: {},
            wallet_transactions: {},
            current_wallet_balance: 0,
            to_pay_out: 0,
            wallet_payment_message:'',
            wallet_payment_error_message:'',
            min_wallet_topup_amount: 100,
            max_wallet_topup_amount:10000,
            wallet_payment_calculated:false,
            disable_topup_wallet_btn:false,
            // loading:true,
            //./wallet calls

            headerKey:0,
            dataBundleComponentKey:0,
            mainSiteUrl:service.mainSiteUrl,

            //site reload
            transaction_processed_reload:false,

            //
            save_service_data_prompt: false,
            show_set_service_saved_data:false,
            saved_services_data: {},
            set_service_saved_data:{},
            
            //
            show_payment_receipt: false,
            payment_receipt_details:{},
            downloading: false,
            //
            service_charge:0,
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'horizontal-widget': HorizontalWidget,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        showLoading(id){
            var x = document.getElementById(id);
            if(id.includes("xs")){
                document.getElementById(id).classList.add('wn-loader-xs');
            }
        },
        closeModal(modal){
            if(modal == 'login'){
                $(modal).modal("hide");
            }else{
                location.reload(); // use for now to solve issues on close
                $(modal).modal("hide");
                if(modal == 'paywith'){this.reset();}
                this.login_script = '';
                this.disable_btn_wallet = false; //recheck
                this.disable_btn = false; //recheck
                this.disable_topup_wallet_btn = false;
                this.wallet_payment_message = '';
                this.save_service_data_prompt = false;

                //remove all form bindings
                this.paga_airtime_request = {};
                this.paga_bundle_request = {};
                this.customer = {};

                ///XXReload
                if(this.transaction_processed_reload){
                    location.reload();
                }
                ///XXReload
            }
        },
        scrollToTop(){
            //scrolls to the very top
            var top = document.getElementById("topwrap").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
            //scrolls
        },
        setLogin(){
            //open modal
            $('#login').modal();
        },
        reset(){
            this.show_code_details = false;
            this.show_paga_service_details = false;
            this.show_airtime_form_details = false;
            this.total_fee = 0;
            this.payment_message = '';
            this.data_error_message = "";
            this.paga_merchant = {};
            this.disable_btn = false;
            // $('#paywith').modal("hide");//recheck----//let user close
        },
        reset_flow(){//DEPRAC SOON CASE:X02
            this.payment_message = 'processing';//dummy message
            this.total_fee = 0;
            this.data_error_message = "";
            this.paga_merchant = {};
            this.disable_btn = false;
        },
        reset_payment_flow(){
            this.disable_btn = false;
            //add more if neccessary..//but don;t disrupt flow
        },
        resetServiceToPay(){
            this.paga_merchant.serviceToPay = false;
            this.serviceToPayComponentKey++;
        },
        resetServiceToPayAmount(){
            this.paga_merchant.serviceToPay.servicePrice = 0;
        },
        reset_data_bundle(){
            this.show_data_bundle_phone_number_field = false;
            this.paga_merchant.serviceToPay = {};
        },
        processCode(){
            this.reset()//reset//activate here CASE:X01
            if((this.rrr.rrr_code == '') || (this.rrr.rrr_code == undefined)){
                this.rrr_err_message = "Please Enter RRR Code";
            }else{
                this.disable_btn = true;
                this.rloading = true;
                let self = this;

                //strip and filter rrr code 
                let sanitized_rrr_code = this.rrr.rrr_code.replace(/\D/g,'');
                //encode request id
                
                // prepare timestamp
                var timestamp = new Date().getTime();

                // Encode the String
                var encodedString = btoa(unescape(encodeURIComponent(timestamp)));
                //console.log(encodedString); // 
                
                var credentials = {
                    rrr_code: sanitized_rrr_code, //rrr_code: this.rrr.rrr_code,
                    rrr_request_id: encodedString
                }
                var payload = {
                    "jsonp": "jp",
                    "ProcessingInfo":[
                        {
                            "name":"AGENTCODE",
                            "value":"CIEJPM"//"BQMHRX"
                            
                        }
                    ]
                }

                //connect to remita
                service.remitaRRRLookup(this, credentials, payload).then(response => {
                    let n_json = response.bodyText;
                    // parse/filter `jsonp`'s value if necessary
                    
                    // wrap the JSON-P in a dynamically-defined function
                    var f = new Function( 'jsonp', n_json);
                    
                    // `f` is now basically:
                    // function f(foo) {
                    //    foo({"id":42});
                    // }
                    
                    // now, provide a non-global `foo()` to extract the JSON
                    f( function(json){
                    //console.log( json.txn.RRRAMOUNT ); // 42
                    //self.notifyRemitaPayment();
                    if((json.responseCode) && (json.responseCode != "SUCCESS")){
                            self.rrr_err_message = json.responseMessage;
                            self.rloading = false;
                    }else{
                            self.rrr_details = json;
                            self.rrr_txn_details = json.txn;
                            self.show_code_details = true;
                            //calc total processing fee and total fee t pay
                            let cnpay_charge = 0;
                            let total_remita_amt = (self.rrr_txn_details.RRRAMOUNT+self.rrr_txn_details.CHARGES);
                            //calc cnpay charge
                            if(total_remita_amt <= self.range_1_max){
                                cnpay_charge = self.range_1_pay;
                            }else if(total_remita_amt <= self.range_2_max){ 
                                cnpay_charge = self.range_2_pay;
                            }else if(total_remita_amt >= self.range_2_max){
                                cnpay_charge = self.range_3_pay;
                            }
                            self.cnpay_proc_fee = cnpay_charge + (total_remita_amt * self.ravecomm);
                            //deduct ravepaycomm and cnpay_charge
                            self.total_fee = ((total_remita_amt + (total_remita_amt * self.ravecomm))+cnpay_charge);
                            self.rloading = false;
                            //round me
                            self.total_fee = Number( self.total_fee.toPrecision(5) )
                            self.cnpay_proc_fee = Number( self.cnpay_proc_fee.toPrecision(5) )
                    }
                    
                    } )
                }).catch((err) => {
                    this.rloading = false;
                    this.rrr_err_message = "Code Validation, Failed"
                // console.log(4545+"-error")
                    //console.log(err)
                })

            }
            

            
        },

        notifyRemitaPayment(){
            this.onboarding = true;
            this.disable_btn = true;
            let self = this;
           // console.log("jhggg"+self.cnpay_post_txn_id)
            // prepare timestamp
            var timestamp = new Date().getTime();

            // Encode the String
            var encodedString = btoa(unescape(encodeURIComponent(timestamp)));
            //console.log(encodedString); // 
            
            var credentials = {
                rrr_code: this.rrr_details.RRR,
                rrr_request_id: encodedString
            }
            var payload = {
                "ProcessingInfo":[
                    {
                        "name":"AGENTCODE",
                        "value":"CIEJPM"//"BQMHRX"
                    }
                ]
            }

            //connect to remita
            service.remitaPaymentNotification(this, credentials, payload).then(response => {
                
                let n_json = response.bodyText;
                var f = new Function( 'jsonp', n_json);
               f( function(json){
                    //update db with remita's response
                    let payload={
                        "rrr_notify_responseCode": json.responseCode,
                        "rrr_notify_responseId": json.responseId,
                        "rrr_notify_responseMessage": json.responseMessage
                    };
                    //update
                    //notify user for failed remita notification
                    if(json.responseCode != "00"){
                        self.payment_message = "Sorry your Payment-Update-Process could not be completed, Please contact cnpay@cityneeds.ng";
                    }
                    service.updateCNpayPaymentNotification(self,self.cnpay_post_txn_id,payload).then(response22 => {
                        self.afterProcessing(0,service.service_payment_circle_fully_successful);
                    }).catch((err) => {
                        // console.log(err)
                        self.afterProcessing(1,service.service_payment_circle_not_fully_successful);
                    })
                    // self.onboarding = true;
                    
                    //afterprocess
                } )
            
            }).catch((err) => {
              //  console.log(34545)
                //console.log(err)
            })


            
        },

        setProcessPayment(){
            this.login_script = false; //reset
            //open modal
            $('#paywith').modal();
        },
        
        //REMITA
        prepProcessPayment(pay_with_option){
            this.disable_btn = true;
            if(pay_with_option == "gateway"){
                //CALL PAYMENT GATEWAY
                this.processPayment();
            }else{
                this.processPaymentWithWallet()
            }
            
        },

        processPayment() {
            let self = this;
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_live_remita, //api public live key
                // PBFPubKey: service.ravepay_public_test, //api public test key //devlot
                customer_email: self.rrr_txn_details.PAYEREMAIL, // "mail@gmail.com"
                amount: self.total_fee,
                customer_phone: self.rrr_txn_details.PAYERNUMBER, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                txref: "CNpay-"+self.rrr_txn_details.transactionId,
                meta: [{
                    metaname: "CNpay",
                    metavalue: self.rrr_txn_details.PAYERNAME
                }],
                onclose: function() {},
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.processing = true;
                        
                        // redirect to a success page
                       // console.log("good to go!"+txref)

                        
                        //server validation
                        let payload =
                        {
                           "SECKEY": service.ravepay_secret_live_remita, //use API secret live key
                            "txref": txref
                        };
                        service.verifyRavePayment(self, payload).then(response => {
                            // console.log(response); // 42
                            // console.log(response.body.data.status); // 42
                            if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                                //check if the amount is same as amount you wanted to charge just to be very sure
                                self.payment_message = "Payment processed successfully. Check your email for your receipts."
                                
                                if (response.body.data.amount === tx_amount) {
                                     //enter into db
                                    let txn_payload={
                                        "txn_ref": txref,
                                        "rrr": self.rrr_details.RRR,
                                        "payername": self.rrr_txn_details.PAYERNAME,
                                        "payeremail": self.rrr_txn_details.PAYEREMAIL,
                                        "payernumber": self.rrr_txn_details.PAYERNUMBER,
                                        "rrr_amount": self.rrr_txn_details.RRRAMOUNT,
                                        "rrr_charges": self.rrr_txn_details.CHARGES,
                                        "cnpay_charges": self.cnpay_proc_fee,
                                        "total_paid_amt": tx_amount,
                                        "payer_logged": self.loggedIn,
                                        "payer_user_id": self.user.user_id || 0,

                                    };
                                    //post
                                    service.postCNpayPaymentDetails(self,txn_payload).then(response => {
                                        self.cnpay_post_txn_id = response.body.txn;
                                        //notify remita of payment
                                       self.notifyRemitaPayment();
                                        let txn_payload00 = {
                                            "transaction_payment_ref": txref, //use here still
                                            "transaction_module": 19, //CNpayments Remita
                                            "transaction_module_id": self.cnpay_post_txn_id,
                                            "transaction_type": 7, //CNpay Remita
                                            "transaction_mode": 2, //CNrewards-Wallet
                                            "transaction_mode_transaction_ref":txref, //use here still
                                            "transaction_amount_paid": tx_amount,
                                            "payer_name": self.rrr_txn_details.PAYERNAME || "",
                                            "payer_email": self.rrr_txn_details.PAYEREMAIL || "", 
                                            "payer_phone": self.rrr_txn_details.PAYERNUMBER || 0,
                                            "payer_user": self.user.user_id || 0,
                                        };
                                        //post
                                        self.postCNpaymentDetails(txn_payload00);
                                        //...//post to txn
                                     }).catch((err) => {
                                        //console.log(err)
                                    })
                                }
                            }
                           
                            
                        }).catch((err) => {
                            //console.log(34545)
                           // console.log(err)
                        })
                        //...//....server validation
                    } else {
                        // redirect to a failure page.
                        //console.log("bad to go!"+txref)
                        self.payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
    
                    x.close(); // use this to close the modal immediately after payment.
                }
            });
        },

        processPaymentWithWallet(){
            this.disable_btn_wallet = true;
            let tx_amount = this.total_fee;
            let tx_ref = "CNpay-"+this.rrr_txn_details.transactionId;

            let self = this;

            var payload ={
                pay: this.user.user_id, // 
                txn_amount: tx_amount,
                service: 4,//Remita CNpay
                service_ref: tx_ref
            }
            service.postWalletPayout(this, payload).then(response => {
                if(response.body.status == 201) {
                    self.payment_message = "Payment processed successfully, check your email for your receipts."
                    // this.updatePayment(response.body.data)
                    //enter into db
                    let txn_payload={
                        "txn_ref": tx_ref,
                        "rrr": self.rrr_details.RRR,
                        "payername": self.rrr_txn_details.PAYERNAME,
                        "payeremail": self.rrr_txn_details.PAYEREMAIL,
                        "payernumber": self.rrr_txn_details.PAYERNUMBER,
                        "rrr_amount": self.rrr_txn_details.RRRAMOUNT,
                        "rrr_charges": self.rrr_txn_details.CHARGES,
                        "cnpay_charges": self.cnpay_proc_fee,
                        "total_paid_amt": tx_amount,
                        "payer_logged": this.loggedIn,
                        "payer_user_id": this.user.user_id || 0,

                    };
                    //post
                    service.postCNpayPaymentDetails(self,txn_payload).then(response => {
                        self.cnpay_post_txn_id = response.body.txn;
                        //notify remita of payment
                        self.notifyRemitaPayment();
                        //post to txn
                        var txref = response.body.data_txn_ref;
                        let txn_payload00 = {
                            "transaction_payment_ref": tx_ref,
                            "transaction_module": 19, //CNpayments Remita
                            "transaction_module_id": self.cnpay_post_txn_id,
                            "transaction_type": 7, //CNpay Remita
                            "transaction_mode": 2, //CNrewards-Wallet
                            "transaction_mode_transaction_ref":txref, //use here
                            "transaction_amount_paid": tx_amount,
                            "payer_name": self.rrr_txn_details.PAYERNAME || "",
                            "payer_email": self.rrr_txn_details.PAYEREMAIL || "", 
                            "payer_phone": self.rrr_txn_details.PAYERNUMBER || 0,
                            "payer_user": self.user.user_id || 0,
                        };
                        //post
                        self.postCNpaymentDetails(txn_payload00);
                        //...//post to txn
                        this.disable_btn_wallet = false;
                    }).catch((err) => {
                        //console.log(err)
                    })
                }
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //./REMITA

        ////txn
        postCNpaymentDetails(txn_payload){
            let self = this;
            service.postCNpaymentDetails(self,txn_payload).then(response => {
                let message = response.body.message;
                self.payment_process_option = 0;
                if(response.body.status == 200){
                    self.payment_status = 200;
                    self.data_processing_message = service.service_payment_circle_fully_successful;
                    //set-moda-msg
                    localStorage.setItem("payment_modal_message",self.data_processing_message);   
                }else if(response.body.status == 400){
                    self.payment_status = 400;
                    self.data_processing_message = service.service_payment_circle_not_fully_successful+'\nIssue: '+message;
                    //set-moda-msg
                    localStorage.setItem("payment_modal_message",self.data_processing_message);
                    localStorage.setItem("reslove_issues",message);
                 }
                //self.afterPostPayment(respose.body.data);
                //x.close(); // use this to close the modal immediately after payment.
            }).catch((err) => {
                // console.log(err)
            })
        },
        //..//txn

        //setts
        check_max_amount_purchase(set_max,amount){
            let check = false;
            if(set_max == 0){
                check = true;
            }else{
                if(amount > set_max){
                    check = false;
                }else{
                    check = true;
                }
            }
            return check;
        },

        //PAGA
        prepPagaAirtimeServices(merchant,show_loading) {
            this.reset(); //reset//activate here CASE:X01
            this.show_data_bundle = false;//reset 
            this.show_data_bundle_phone_number_field = false;
            this.paga_merchant = merchant;
            // this.showLoading(show_loading);
            this.paga_merchant.loading = true;
            this.show_airtime_form_details = true;
            this.is_paga_mobileops_purchase = true;//for resolving transction purchase
            this.getServiceSavedData(merchant.paga_service_group_merchant_id); //get saved details
            //        
            this.scrollToTop();

            //more reset
            this.is_paga_merchant_purchase = false;
        },

        setPagaAirtimeOrDataBundle(){
            if(this.show_data_bundle){
                this.show_data_bundle = false;
            }else{
                this.show_data_bundle = true;
            }
        },

        prepSetPagaProcessPayment(paga_service,service_for){
            //resets
            this.data_error_message = '';
            this.customer.customerCodeAtBiller = '';

            this.paga_merchant.serviceToPay = paga_service;
            if(this.paga_merchant.serviceToPay.servicePrice == 0){
                this.paga_merchant.serviceToPay.servicePrice = ''; //so that 0 will not show
            }

            this.paga_merchant.serviceToPay.servicePrice_store = this.paga_merchant.serviceToPay.servicePrice; //use as a store incase price is post-set
            this.paga_merchant.serviceToPay.serviceNameStored = this.paga_merchant.serviceToPay.serviceName;
            this.serviceToPayFor = service_for;
            this.serviceToPayComponentKey++;
            this.setPayWithOption = false;

            //more reset
            this.is_paga_mobileops_purchase = false;
            
            $('#paywith').modal();
        },

        prepDataBundleSetPagaProcessPayment(service,service_for){
            this.paga_bundle_request = service;
            this.paga_merchant.serviceToPay = service;
            this.show_data_bundle_phone_number_field = true;
            this.serviceToPayFor = service_for;
            this.dataBundleComponentKey++;
        },

        setPagaProcessPayment(paga_service,service_for){
            let can_process = false; 

            //check max purchase effect
            let check_max_purchase_effect = false; //ini
            if(service_for == 'MOBILEOPS'){
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount,this.paga_airtime_request.amount);
            }else if(service_for == 'MOBILEDATA'){
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount,this.paga_merchant.serviceToPay.servicePrice);
            }else{
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount,this.paga_merchant.serviceToPay.servicePrice);
                //
                if(this.customer.customerName != '' && (this.customer.customerName != undefined)){
                    if(this.customer.customerCodeAtBiller != '' && (this.customer.customerCodeAtBiller != undefined)){
                        can_process = true;
                    }else{
                        can_process = false;
                        this.data_error_message = "Enter your number";
                    }
                }else{
                    can_process = false;
                    this.data_error_message = "Enter your details";
                }
            }
            //
            if(check_max_purchase_effect){
                can_process = true;
            }else{
                can_process = false;
                this.data_error_message = service.service_amt_out_of_range_msg;
            }
            //
            
            if(can_process){
                this.scrollToTop;
                this.disable_btn = true;
                this.setPayWithOption = false;
                let service_amt = 0;
                let paga_proc_fee =  0;
                let data_test = false;
                this.paga_merchant.serviceToPay = paga_service;
                

                ///do customer naming for merchants only
                if(service_for == 'MERCHANT'){
                    let name_split = this.customer.customerName.split(" ");
                    this.customer.customerFirstName = name_split[0];
                    this.customer.customerLastName = name_split[1];
                    if(this.customer.customerLastName == undefined){
                        this.customer.customerLastName =  this.customer.customerFirstName;
                    }
                }
                // console.log(this.customer)
                //preps 
                this.setCustomerDetails();
                //../preps

                //MERCHANT
                if(service_for == 'MERCHANT'){
                    service_amt = parseFloat(paga_service.servicePrice);
                    data_test = true; 
                    //trim to remove preceeding and trailing spaces
                    //this.customer.customerCodeAtBiller = (this.customer.customerCodeAtBiller).trim();
                    this.customer.customerCodeAtBiller = (this.customer.customerCodeAtBiller).toString().trim();
                    //validate
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let email_test = re.test(String(this.customer.customerEmail).toLowerCase());
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    // let phone_test = re_phone.test(String(this.customer.customerPhoneNumber).toLowerCase());
                    let phone_test_0 = re_phone.test(String(this.customer.customerPhoneNumber).toLowerCase());
                    let phone_test = true;
                    if(phone_test_0 == false){
                        this.data_error_message = "Your Phone Number is not correct. Please fill correctly";
                    }
                    if((email_test == false) || (this.customer.customerFirstName == " ") || (phone_test == false)){
                        data_test = false;
                        if(email_test == false){
                            this.data_error_message = "Your Email is not correct. Please fill correctly";
                        }
                        else if(phone_test_0 == false){
                            this.data_error_message = "Your Phone Number is not correct. Please fill correctly";
                        }else{
                            this.data_error_message = "Some errors were found in your form. Please, fill correctly";
                        }
                        
                        this.disable_btn = false;
                    }else{
                        data_test = true;
                        this.data_error_message = "";
                        this.disable_btn = true;
                    }
                    //..../validate
                    //if validated
                    if(data_test){ 
                        // this.paga_merchant.serviceToPay.serviceNameStored = this.paga_merchant.serviceToPay.serviceName;
                        //validate pre purchase /validateMerchantFee 
                        //let seek_url = service.paga_apiBaseUrl+"secured/validatePayMerchant";
                        //let seek_url = service.paga_apiBaseUrl+"getMerchantAccountDetails";
                        let seek_url = service.paga_apiBaseUrl+"validateMerchantPayment";
                        var payload = {
                            // "referenceNumber":this.today.getTime(),
                            // "locale": "", 
                            // "billerPublicId":this.paga_merchant.paga_service_group_merchant_billerPublicId,
                            // "customerCode": this.customer.customerCodeAtBiller,
                            // "customerPhoneNumber":this.customer.customerPhoneNumber,
                            // "amount":this.paga_merchant.serviceToPay.servicePrice,
                            // "serviceName":this.paga_merchant.serviceToPay.serviceNameStored,
                            //
                            //-----getMerchantAccountDetails
                            // "referenceNumber":this.today.getTime(),
                            // "merchantAccount":this.paga_merchant.paga_service_group_merchant_billerPublicId,
                            // "merchantReferenceNumber":this.customer.customerCodeAtBiller,
                            // "merchantServiceProductCode":this.paga_merchant.serviceToPay.code,
                            //-----
                            //
                            "referenceNumber": this.today.getTime(),
                            "amount": this.paga_merchant.serviceToPay.servicePrice,
                            "merchantAccount": this.paga_merchant.paga_service_group_merchant_billerPublicId,
                            "merchantReferenceNumber": this.customer.customerCodeAtBiller,
                            "merchantServiceProductCode":this.paga_merchant.serviceToPay.code,
                        }
                        //let hash = service.SHA512(payload.referenceNumber + payload.billerPublicId + payload.customerCode+ payload.customerPhoneNumber + payload.amount + service.paga_apiKey);
                        let hash = service.SHA512(String(payload.referenceNumber) + String(payload.amount) + payload.merchantAccount + payload.merchantReferenceNumber + service.paga_apiKey);
                        let self = this;
                        service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                            if(data.body.responseCode == 0){
                                //getMerchantAccountDetails
                                let seek_url = service.paga_apiBaseUrl+"getMerchantAccountDetails";
                                var payload = {
                                    "referenceNumber":this.today.getTime(),
                                    "merchantAccount":this.paga_merchant.paga_service_group_merchant_billerPublicId,
                                    "merchantReferenceNumber":this.customer.customerCodeAtBiller,
                                    "merchantServiceProductCode":this.paga_merchant.serviceToPay.code,
                                }
                                let hash = service.SHA512(String(payload.referenceNumber) + payload.merchantAccount + payload.merchantReferenceNumber + payload.merchantServiceProductCode + service.paga_apiKey);
                                let self = this;
                                service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                                    if(data.body.responseCode == 0){
                                        //contd
                                        this.customer_received_details = data.body.details;data.body.accountDetails;
                                        //calc total_fee with commission
                                        //calc comm
                                        if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                                            paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                                        }
                                        if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                                            paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                                        }
                                        this.total_fee = parseFloat((service_amt + paga_proc_fee));
                                        this.service_charge = (paga_proc_fee);
                                        //more settings //add to this.paga_merchant.serviceToPay.serviceName
                                        this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.paga_service_group_merchant_displayName+"-"+this.paga_merchant.serviceToPay.serviceName+"--"+this.customer.customerCodeAtBiller;
                                        // this.payment_service_message = this.paga_merchant.serviceToPay.serviceName;
                        
                                        this.disable_btn = false;
                                        this.login_script = false; //reset
                                        //open modal
                                        // $('#paywith').modal();
                                        this.setPayWithOption = true;
                                        //../contd 38006
                                    }else{
                                        this.disable_btn = false;
                                        this.data_error_message = "Your details were not validated. Please, check your details: Your "+this.paga_merchant.paga_service_group_merchant_displayName+" Number, Amount Paid, Phone Number etc...";
                                        //--reset amount for editable service pay
                                        if(this.paga_merchant.serviceToPay.servicePrice_store == 0){
                                            this.resetServiceToPayAmount();
                                        }
                                    }
                                }).catch((err) => {})
                            }else if((data.body.responseCode == -1) || (data.body.responseCode == 38033) || (data.body.responseCode == 38051) || (data.body.responseCode == 37005) || (data.body.responseCode == 38015)){
                                this.disable_btn = false;
                                if(data.body.responseCode == 38051){
                                    this.data_error_message = "Please review your details, the Amount to Purchase does not match";
                                }
                                else if(data.body.responseCode == 37005){
                                    this.data_error_message = data.body.message;
                                }
                                else if(data.body.responseCode == 38015){
                                    this.data_error_message = "Please review your details, account seems inactive";
                                }else{
                                    this.data_error_message = "Your details were not validated. Please, review your details: Your "+this.paga_merchant.paga_service_group_merchant_displayName+" Number, Phone Number etc... Amount to Purchase may be too low.";
                                }
                                //reset amount
                                //--reset amount for editable service pay
                                if(this.paga_merchant.serviceToPay.servicePrice_store == 0){
                                    this.resetServiceToPayAmount();
                                }
                            }else{
                                if(data.body.responseCode == 37006){ //insufficient funds
                                
                                    //post error message
                                    var msg = {
                                        "message_from":"System Services",
                                        "message_body": "Your Paga Balance could not process a Service Amount of: "+this.paga_merchant.serviceToPay.servicePrice+". Increase your Paga Balance to process amount such as this. "+" PAGA Response Code: "+data.body.responseCode+"." 
                                    }
                                    service.postMessages(this,msg).then(data => {});
                                }
                                if(data.body.responseCode == 38006){ //Merchant not authorized for payments on this channel
                                
                                    //post error message
                                    var msg = {
                                        "message_from":"System Services",
                                        "message_body": this.paga_merchant.paga_service_group_merchant_displayName+" Merchant Paga Payment Failed- "+data.body.message+". PAGA Response Code: "+data.body.responseCode+"." ,
                                    }
                                    service.postMessages(this,msg).then(data => {});
                                }
                                //show message
                                this.data_error_message = this.paga_merchant.paga_service_group_merchant_displayName+"  Payment could not be proccessed. ...reloading CNpay";
                                //some unset
                                this.paga_merchant.serviceToPay.servicePrice = this.paga_merchant.serviceToPay.servicePrice_store;
                                this.disable_btn = false;
                                //./some unset
                                let self = this;
                                setTimeout(function (){
                                    $('#paywith').modal("hide");
                                    self.reset();
                                }, 30000);
                            }
                        }).catch((err) => {})
                    }else{
                        this.disable_btn = false;
                    }
                    
                    // if(data_test){ 
                    //     if(service_amt > 0){
                    //         //contd
                    //         this.customer_received_details = data.body.accountDetails;
                    //         //calc total_fee with commission
                    //         //calc comm
                    //         if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                    //             paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                    //         }
                    //         if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                    //             paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                    //         }
                    //         this.total_fee = parseFloat((service_amt + paga_proc_fee));
                    //         this.service_charge = (paga_proc_fee);
                    //         //more settings //add to this.paga_merchant.serviceToPay.serviceName
                    //         this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.paga_service_group_merchant_displayName+"-"+this.paga_merchant.serviceToPay.serviceName+"--"+this.customer.customerCodeAtBiller;
                    //         // this.payment_service_message = this.paga_merchant.serviceToPay.serviceName;
            
                    //         this.disable_btn = false;
                    //         this.login_script = false; //reset
                    //         //open modal
                    //         // $('#paywith').modal();
                    //         this.setPayWithOption = true;
                    //         //../contd 38006
                    //     }
                    // }else{
                    //     this.disable_btn = false;
                    // }
                }

                //MOBILEOPS
                if(service_for == 'MOBILEOPS'){
                    //validate phone number and amount entered
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    let phone_test = re_phone.test(String(this.paga_airtime_request.phone_no).toLowerCase());
                    if((this.paga_airtime_request.amount == " ") || (phone_test == false)){
                        if((phone_test == false)){
                            this.data_error_message = "Phone Number seems incorrect.";
                        }else{
                            this.data_error_message = "Some errors were found in your form. Please, fill correctly.";
                        }
                        data_test = false;
                        this.disable_btn = false;
                    }else{
                        data_test = true;
                        this.data_error_message = "";
                    }
                    if((this.paga_airtime_request.amount == '') || (this.paga_airtime_request.amount == undefined)){
                        data_test = false;
                        this.disable_btn = false;
                        this.data_error_message = "Enter Amount";
                    }else{
                        if(this.paga_airtime_request.amount < 50){
                            data_test = false;
                            this.disable_btn = false;
                            this.data_error_message = "Enter Minimum Amount of 50.";
                        }
                    }
                    

                    if(data_test){
                        //check if purchase is valid
                        let self = this;
                            //ok //continue
                                service_amt = parseFloat(this.paga_airtime_request.amount);
                                //more settings
                                this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.paga_service_group_mobile_operatorName+"--"+this.paga_airtime_request.phone_no;
                                this.paga_merchant.serviceToPay.servicePrice = this.paga_airtime_request.amount;
                                // this.payment_service_message = this.paga_merchant.serviceToPay.serviceName;
                                //./ok.cont
                                //if validated
                                //calc total_fee with commission
                                //calc comm
                                if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                                    paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                                }
                                if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                                    paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                                }

                                this.total_fee = parseFloat((service_amt + paga_proc_fee));
                                this.service_charge = (paga_proc_fee);
                                this.disable_btn = false;
                                this.login_script = false; //reset
                                this.setPayWithOption = true;
                                //open modal
                                $('#paywith').modal();
                                //if validated
                    }else{
                        this.disable_btn = false;
                    }

                    /*if(data_test){
                        if(this.paga_airtime_request.amount > 0){ //use not equals for now till paga settle txns
                            //ok //continue
                            service_amt = parseFloat(this.paga_airtime_request.amount);
                            //more settings
                            this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.paga_service_group_mobile_operatorName+"--"+this.paga_airtime_request.phone_no;
                            this.paga_merchant.serviceToPay.servicePrice = this.paga_airtime_request.amount;
                            //./ok.cont
                            //if validated
                            //calc total_fee with commission
                            //calc comm
                            if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                                paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                            }
                            if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                                paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                            }

                            this.total_fee = parseFloat((service_amt + paga_proc_fee));
                            this.service_charge = (paga_proc_fee);
                            this.disable_btn = false;
                            this.login_script = false; //reset
                            this.setPayWithOption = true;
                            //open modal
                            $('#paywith').modal();
                            //if validated
                        }
                    }else{
                        this.disable_btn = false;
                    }*/
                        
                }

                //MOBILEDATA
                if(service_for == 'MOBILEDATA'){
                    //validate phone number and amount entered
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    let phone_test = re_phone.test(String(this.paga_bundle_request.phone_no).toLowerCase());
                    if((phone_test == false)){
                        this.data_error_message = "Phone Number seems incorrect.";
                        data_test = false;
                        this.disable_btn = false;
                    }else{
                        data_test = true;
                        this.data_error_message = "";
                    }

                    /*if(data_test){
                        //check if purchase is valid
                        // let seek_url = service.paga_apiBaseUrl+'secured/getPurchaseAirtimeFee';
                        let seek_url = service.paga_apiBaseUrl+'secured/validatePurchaseAirtime'; 
                        
                        var payload = {
                            "referenceNumber": this.today.getTime(),
                            "locale": "", 
                            "receiverPhoneNumber":this.paga_bundle_request.phone_no,
                            "amount":this.paga_merchant.serviceToPay.servicePrice,
                            "quantity":1,
                            "message":"",
                            "identificationType":"",
                            "identificationNumber":"",
                            "operatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                            "isDataBundle":true,
                            "networkServiceId": this.paga_merchant.serviceToPay.serviceId //serviceId
                        }
                    
                        let hash = service.SHA512(payload.referenceNumber +payload.receiverPhoneNumber + payload.amount + service.paga_apiKey);
                                         
                        let self = this;
                        service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                            if(data.body.responseCode != 0){ //use not equals for now till paga settle txns
                                //ok //continue
                                service_amt = parseFloat(this.paga_merchant.serviceToPay.servicePrice);
                                //more settings
                                this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.serviceToPay.serviceName+"--"+this.paga_bundle_request.phone_no; 
                                // this.payment_service_message = this.paga_merchant.serviceToPay.serviceName;
                                //calc total_fee with commission
                                //calc comm
                                if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                                    paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                                }
                                if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                                    paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                                }

                                this.total_fee = parseFloat((service_amt + paga_proc_fee));
                                this.service_charge = (paga_proc_fee);
                                this.disable_btn = false;
                                this.login_script = false; //reset
                                this.setPayWithOption = true;
                                //open modal
                                $('#paywith').modal();
                                //if validated
                            }
                            if(data.body.responseCode == -1){
                                this.disable_btn = false;
                                //cmment for now till paga sorts proper validation
                                // this.data_error_message = "Your details were not validated. Please, check your details: phone number and recharge amount.";
                            }else{
                                this.disable_btn = false;
                                this.data_error_message = "Data Bundle could not be purchased";
                            }
                        }).catch((err) => {})
                        //check if purchase is valid
                    }else{
                        this.disable_btn = false;
                    }*/

                    if(data_test){
                        //check if purchase is valid
                        if(this.paga_merchant.serviceToPay.servicePrice > 0){ //use not equals for now till paga settle txns
                            //ok //continue
                            service_amt = parseFloat(this.paga_merchant.serviceToPay.servicePrice);
                            //more settings
                            this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.serviceToPay.serviceName+"--"+this.paga_bundle_request.phone_no; 
                            // this.payment_service_message = this.paga_merchant.serviceToPay.serviceName;
                            //calc total_fee with commission
                            //calc comm
                            if(this.paga_merchant.paga_service_group_merchant_commission_type == 'P'){
                                paga_proc_fee = parseFloat(((this.paga_merchant.paga_service_group_merchant_commission / 100) * service_amt));
                            }
                            if(this.paga_merchant.paga_service_group_merchant_commission_type == 'C'){
                                paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                            }

                            this.total_fee = parseFloat((service_amt + paga_proc_fee));
                            this.service_charge = (paga_proc_fee);
                            this.disable_btn = false;
                            this.login_script = false; //reset
                            this.setPayWithOption = true;
                            //open modal
                            $('#paywith').modal();
                            //if validated
                        }
                        //check if purchase is valid
                    }else{
                        this.disable_btn = false;
                    }
                        
                }

            }else{
                this.disable_btn = false;
                //free editable price interface
                if(this.paga_merchant.serviceToPay.servicePrice_store == 0){
                    this.resetServiceToPayAmount();
                }
            }
        },
        
        prepPagaProcessPayment(pay_with_option){
            this.disable_btn = true;
            this.disable_btn_wallet = true;
            let data_test = false;
                
            //if loggedIn set user as customer
            if(this.loggedIn){
               this.setCustomerDetails();
                // this.customer.customerPhoneNumber = this.user.user_phone;
                data_test = true;
            }else{
                data_test = true;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let email_test = re.test(String(this.customer.customerEmail).toLowerCase());
                //set names
                if((this.customer.customerName != '') && (this.customer.customerName != undefined)){
                    let name_split = this.customer.customerName.split(" ");
                    this.customer.customerFirstName = name_split[0];
                    this.customer.customerLastName = name_split[1];
                    if(this.customer.customerLastName == undefined){
                        this.customer.customerLastName =  this.customer.customerFirstName;
                    }
                }else{
                    this.customer.customerFirstName = "Nil";
                    this.customer.customerLastName = "Nil";
                }
                //commented for now as pre-validation for merhant has happened earlier
                // var re_phone = /^\d{4}\d{3}\d{4}$/;
                // let phone_test = re_phone.test(String(this.customer.customerPhoneNumber).toLowerCase());
                // if((email_test == false) || (this.customer.customerFirstName == " ") || (phone_test == false)){
                //     data_test = false;
                //     this.data_error_message = "Some errors were found in your form. Please, fill correctly";
                // }else{
                //     data_test = true;
                //     this.data_error_message = "";
                // }
                //commented for now as pre-validation for merhant has happened earlier
                if((email_test == false)){
                    data_test = false;
                    this.data_error_message = "Your Email is not correct. Please, fill correctly";
                }else{
                    data_test = true;
                    this.data_error_message = "";
                }
               
            }
            if(data_test){
                if(pay_with_option == "gateway"){
                    //CALL PAYMENT GATEWAY
                   this.processPagaPayment();
                }else{
                   this.processPagaPaymentWithWallet()
                }
            } 
        },

        processPagaPayment() {
            let self = this;
            let test_mode = false;
            if(test_mode){
                console.log("test_mode: chilling here");
                if(self.is_paga_merchant_purchase){
                    //pay paga merchant
                    self.payPagaMerchantServices();
                }
                if(self.is_paga_mobileops_purchase){
                    //pay paga purchase airtime
                    self.payPagaPurchaseAirtime();
                }
            }else{
                let self = this;
                //uncmt...paga ravepay payment 
                var x = getpaidSetup({
                    //PBFPubKey: service.ravepay_public_test, //test //devlot
                    PBFPubKey: service.ravepay_public_live_paga, //api public key
                    customer_email: self.customer.customerEmail, // "mail@gmail.com"
                    amount: self.total_fee,
                    customer_phone: self.customer.customerPhoneNumber, //"234099940409"
                    currency: "NGN",
                    payment_method: "both",
                    txref: "CNpayPG-"+this.today.getTime(),
                    meta: [{
                        metaname: "CNpayPG",
                        metavalue: self.customer.customerFirstName + " " + self.customer.customerLastName
                    }],
                    onclose: function() {
                        // self.reset_flow(); 
                        self.reset_payment_flow(); 
                        setTimeout(function (){
                            //DEPRAC CASE:X02
                            // self.reset(); 
                        }, 20000);
                    },
                    callback: function(response) {
                        var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                        var tx_amount = response.tx.amount;
                        if (
                            response.tx.chargeResponseCode == "00" ||
                            response.tx.chargeResponseCode == "0"
                        ) {
                            self.processing = true;
                        //uncmt...paga ravepay payment 

                            // redirect to a success page
                        // console.log("good to go!"+txref)

                            //uncmt...server validation
                            //server validation
                            let payload =
                            {
                            "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                                "txref": txref
                            };
                            service.verifyRavePayment(self, payload).then(response => {
                                // console.log(response); // 42
                                // console.log(response.body.data.status); // 42
                                if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                                    //check if the amount is same as amount you wanted to charge just to be very sure
                                    self.payment_message = "Payment processed successfully."
                                    
                                    if (response.body.data.amount === tx_amount) {
                                //uncmt...server validation
                                        //enter into db
                                        //UNCMT 
                                        let txref = "CNpayPG-"+self.today.getTime();
                                        let tx_amount = self.total_fee;
                                        //UNCMT 
                                        let txn_payload={
                                            "txn_ref": txref,
                                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                                            "paga_merchant_name": self.paga_service_group_merchant_displayName || self.paga_service_group_mobile_operatorName,
                                            "paga_merchant_service_group": self.paga_merchant.paga_service_group_merchant_service_group,
                                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                                            "paga_merchant_service_commission": self.paga_merchant.paga_service_group_merchant_commission,
                                            "payercodeAtBiller": self.customer.customerCodeAtBiller || "Nil",
                                            "payerfirstname": self.customer.customerFirstName || "Nil",
                                            "payerlastname": self.customer.customerLastName || "Nil",
                                            "payeremail":self.customer.customerEmail,
                                            "payerphonenumber": self.customer.customerPhoneNumber || self.paga_airtime_request.phone_no || self.paga_bundle_request.phone_no, //--paga_airtime_request.phone_no--incase not loggedIn
                                            "total_paid_amt": tx_amount,
                                            "payer_logged": self.loggedIn,
                                            "payer_user_id": self.user.user_id || 0,
                                        };
                                        //post
                                        service.postCNpayPagaPaymentDetails(self,txn_payload).then(response => {
                                            self.cnpay_post_txn_id = response.body.txn;
                                            self.cnpay_post_txn_ref = response.body.txn_ref; 
                                            if(self.is_paga_merchant_purchase){
                                                //pay paga merchant
                                                self.payPagaMerchantServices();
                                            }
                                            if(self.is_paga_mobileops_purchase){
                                                //pay paga purchase airtime
                                                self.payPagaPurchaseAirtime();
                                            }
                                            let txn_payload00 = {
                                                "transaction_payment_ref": txref, //use here still
                                                "transaction_module": 20, //CNpayments Paga
                                                "transaction_module_id": self.cnpay_post_txn_id,
                                                "transaction_type": 8, //CNpay Paga
                                                "transaction_mode": 1, //Payment Gateway
                                                "transaction_mode_transaction_ref":txref, //use here still
                                                "transaction_amount_paid": tx_amount,
                                                "payer_name": (self.customer.customerFirstName+self.customer.customerLastName) || "",
                                                "payer_email": self.customer.customerEmail  || "", 
                                                "payer_phone": self.customer.customerPhoneNumber  || 0,
                                                "payer_user": self.user.user_id || 0,
                                            };
                                            //post
                                            self.postCNpaymentDetails(txn_payload00);
                                            //   x.close(); // use this to close the modal immediately after payment.
                                        }).catch((err) => {
                                            // console.log(err)

                                        })
                                    //uncmt...server validation
                                    }
                                }
                            
                                
                            }).catch((err) => {
                                //console.log(34545)
                            // console.log(err)
                            })
                            //uncmt...//....server validation
                        //uncmt...paga ravepay payment 
                        } else {
                            // redirect to a failure page.
                            //console.log("bad to go!"+txref)
                            // self.payment_message = "Payment unsuccessfull. please try again or contact us"
                            self.payment_message = service.service_payment_failed;
                            // self.afterProcessing(1,service.service_payment_failed);
                        }
        
                        // x.close(); // use this to close the modal immediately after payment.
                    }
                });
            }
        },

        processPagaPaymentWithWallet(){
            this.disable_btn_wallet = true;
            let tx_amount = this.total_fee;
            let tx_ref = "CNpayPG-"+this.today.getTime();

            let self = this;

            var payload ={
                pay: this.user.user_id, // 
                txn_amount: tx_amount,
                service: 6,//PAGA CNpay
                service_paga: this.paga_merchant.paga_service_group_merchant_id,//Actual PAGA Merchant Service
                service_transaction_name: this.paga_merchant.serviceToPay.serviceName,
                service_ref: tx_ref
            }
            let test_mode = false;
            if(test_mode){
                console.log("test_mode: chilling here");
                if(self.is_paga_merchant_purchase){
                    //pay paga merchant
                    self.payPagaMerchantServices();
                }
                if(self.is_paga_mobileops_purchase){
                    //pay paga purchase airtime
                    self.payPagaPurchaseAirtime();
                }
            }else{
                service.postWalletPayout(this, payload).then(response => {
                    if(response.body.status == 201) {
                    // this.updatePayment(response.body.data)
                        //enter into db
                        let txn_payload={
                            "txn_ref": tx_ref,
                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_name": self.paga_service_group_merchant_displayName || self.paga_service_group_mobile_operatorName,
                            "paga_merchant_service_group": self.paga_merchant.paga_service_group_merchant_service_group,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_merchant_service_commission": self.paga_merchant.paga_service_group_merchant_commission,
                            "payercodeAtBiller": self.customer.customerCodeAtBiller || "Nil",
                            "payerfirstname": self.customer.customerFirstName || "Nil",
                            "payerlastname": self.customer.customerLastName || "Nil",
                            "payeremail":self.customer.customerEmail || "Nil",
                            "payerphonenumber": self.customer.customerPhoneNumber || "Nil",
                            "total_paid_amt": tx_amount,
                            "payer_logged": this.loggedIn,
                            "payer_user_id": this.user.user_id || 0,
                        };
                        //post
                        service.postCNpayPagaPaymentDetails(self,txn_payload).then(response => {
                            self.cnpay_post_txn_id = response.body.txn;
                            self.cnpay_post_txn_ref = response.body.txn_ref;
                            if(self.is_paga_merchant_purchase){
                                //pay paga merchant
                                self.payPagaMerchantServices();
                            }
                            if(self.is_paga_mobileops_purchase){
                                //pay paga purchase airtime
                                self.payPagaPurchaseAirtime();
                            }
                            //post to txn
                            var txref = response.body.data_txn_ref;
                            let txn_payload00 = {
                                "transaction_payment_ref": tx_ref,
                                "transaction_module": 20, //CNpayments Paga
                                "transaction_module_id": self.cnpay_post_txn_id,
                                "transaction_type": 8, //CNpay Paga
                                "transaction_mode": 2, //CNrewards-Wallet
                                "transaction_mode_transaction_ref":txref, //use here
                                "transaction_amount_paid": tx_amount,
                                "payer_name": (self.customer.customerFirstName+self.customer.customerLastName) || "",
                                "payer_email": self.customer.customerEmail || "", 
                                "payer_phone": self.customer.customerPhoneNumber || 0,
                                "payer_user": self.user.user_id || 0,
                            };
                            //post
                            self.postCNpaymentDetails(txn_payload00);
                            //...//post to txn
                            // this.disable_btn_wallet = false;
                        }).catch((err) => {
                            //console.log(err)
                        })
                        
                        
                    }else{
                        this.payment_message = service.service_payment_failed;
                        // this.afterProcessing(1,service.service_payment_failed);
                    }
                }).catch((err) => {
                    if(err) {
                        ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },

        
        //paga calls
        getPagaServiceGroups() {
            this.loading = true;
            service.getPagaServiceGroups(this).then(data => {
                this.paga_service_groups = data.body.data;
                this.loading =  false;
                //other service calls
                this.getPagaDataBundles();
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
       // https://www.mypaga.com/paga-webservices/business-rest/secured/getMerchants

        getPagaMerchants() { 
            let seek_url = service.paga_apiBaseUrl+'getMerchants';
            let hash = service.SHA512(""+service.paga_apiKey);
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers(),
            }
            service.getPagaRequest(this,payload,seek_url,hash).then(data => {
                if(data.body.responseCode == 0){
                   console.log(3466)
                }
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getPagaMerchantServices(merchant,show_loading) { 
            this.reset(); //reset//activate here CASE:X01
            this.paga_merchant = merchant;
            this.paga_merchant.loading = true;
            // this.showLoading(show_loading);
            // this.tiny_loading = true;
            // let seek_url = 'https://qa1.mypaga.com/paga-webservices/agent-rest/unsecured/getMerchantServices';
            let seek_url = service.paga_apiBaseUrl+'getMerchantServices';
            let hash = "";
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers(),
                "merchantPublicId": merchant.paga_service_group_merchant_billerPublicId
            }
            hash = service.SHA512(String(payload.referenceNumber) + payload.merchantPublicId + service.paga_apiKey);
            service.getPagaRequest(this,payload,seek_url,hash).then(data => {
                if(data.body.responseCode == 0){
                    //this.paga_merchant.services = data.body.billerServices;
                    this.paga_merchant.services = [];
                    let dataload = data.body.services;
                    for(let load of dataload){
                        load.serviceName = load.name;
                        load.servicePrice = load.price;

                        this.paga_merchant.services.push(load);
                    }
                    this.getServiceSavedData(merchant.paga_service_group_merchant_id); //get saved details
                    this.show_paga_service_details = true;
                    this.is_paga_merchant_purchase = true;//for resolving transction purchase
                    this.scrollToTop();
                }
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getPagaDataBundles(){
            //let seek_url = service.paga_apiBaseUrl+"unsecured/getDataBundleByOperatorId";
            let seek_url = service.paga_apiBaseUrl+"getDataBundleByOperator";
            for(let group of this.paga_service_groups){
                if(group.paga_service_group_for == 'MOBILEOPS'){
                    for(let paga_merchant of group.paga_service_group_merchants){
                        var payload = {
                            "referenceNumber":this.getDefaultRandomNumbers(),
                            "operatorPublicId":paga_merchant.paga_service_group_mobile_operatorPublicId
                        }
                        let hash = "";
                        hash = service.SHA512(String(payload.referenceNumber)+payload.operatorPublicId+service.paga_apiKey);
                        service.getPagaRequest(this,payload,seek_url,hash).then(data => {
                            if(data.body.responseCode == 0){
                                paga_merchant.dataBundles = data.body.mobileOperatorServices;
                            }else{
                                paga_merchant.dataBundles = [];
                            }
                            
                        }).catch((err) => {})
                    }
                }
            }

            //single merchant call
            // let seek_url = service.paga_apiBaseUrl+"unsecured/getDataBundleByOperatorId";
            // var payload = {
            //     "operatorPublicId":this.paga_merchant.paga_service_group_mobile_operatorPublicId
            // }
            // let hash = "";
            
            // service.getPagaRequest(this,payload,seek_url,hash).then(data => {
            //     if(data.body.responseCode == 0){
            //         this.paga_merchant.dataBundles = data.body.mobileOperatorServices;
            //         this.dataBundleComponentKey++;
            //     }else{
            //         this.paga_merchant.dataBundles = [];
            //         this.dataBundleComponentKey++;
            //     }
                
            // }).catch((err) => {})
        },

        payPagaMerchantServices() { 
            // let seek_url = 'https://qa1.mypaga.com/paga-webservices/agent-rest/secured/payMerchant';

            // let seek_url = service.paga_apiBaseUrl+'secured/payMerchant';
            let seek_url = service.paga_apiBaseUrl+'merchantPayment';
            
            var payload = {
                // "referenceNumber":this.cnpay_post_txn_ref,
                // "locale": " ", 
                // "billerPublicId":this.paga_merchant.paga_service_group_merchant_billerPublicId,
                // "customerCodeAtBiller": this.customer.customerCodeAtBiller,
                // "customerPhoneNumber":this.customer.customerPhoneNumber,
                // "amount":this.paga_merchant.serviceToPay.servicePrice,
                // "customerFirstName":this.customer.customerFirstName || "",
                // "customerLastName":this.customer.customerLastName || "",
                // "serviceName": this.paga_merchant.serviceToPay.serviceNameStored,
                //
                "merchantReferenceNumber":this.customer.customerCodeAtBiller,
                "amount":this.paga_merchant.serviceToPay.servicePrice,
                "merchantAccount":this.paga_merchant.paga_service_group_merchant_billerPublicId,
                "referenceNumber":this.cnpay_post_txn_ref,
                "currency":"NGN",
                "merchantService":[  
                    this.paga_merchant.serviceToPay.code,
                ],
                "locale":"NG"
            }
           
            // let hash = service.SHA512(payload.referenceNumber + payload.billerPublicId +
            //     payload.customerCodeAtBiller + payload.customerPhoneNumber + payload.amount + service.paga_apiKey);
            let hash = service.SHA512(String(payload.referenceNumber) + String(payload.amount) + payload.merchantAccount +
                payload.merchantReferenceNumber + service.paga_apiKey);
            //continue
            let self = this;
            //
            let test_mode = false;
            if(test_mode){
                console.log("test_mode: chilling here");
                //---setts
                let recharge_token = "1111111111111111111111111111111";
                let formatted_voucher = recharge_token.match(/.{1,4}/g).join('-');
                //
                self.payment_service_message = "Token: "+formatted_voucher;
                self.afterProcessing(0,service.service_payment_circle_fully_successful);
                //save frequent data propmpt
                if(self.save_service_data_prompt){
                    //set_payload
                    var set_payload = {
                        "merchant": self.paga_merchant.paga_service_group_merchant_id,
                        "merchant_service_id": self.paga_merchant.serviceToPay.serviceId || 0,
                        "merchant_number": self.customer.customerCodeAtBiller,
                        "merchant_number_name": self.customer_received_details.customerName,
                        "merchant_user": self.user.user_id || 0,
                    }
                    //
                    self.prepSaveServiceData(set_payload); 
                }
                //../save frequent data propmpt
                //prepare receipt
                var set_details = {
                    "payment_merchant_name": self.paga_merchant.paga_service_group_merchant_displayName,
                    "payment_merchant_logo": self.paga_merchant.paga_service_group_merchant_attached_image,
                    "payment_merchant_service":  self.paga_merchant.serviceToPay.serviceName,
                    "payment_merchant_code_number": self.customer.customerCodeAtBiller,
                    "payment_payer_merchant_name": self.customer_received_details.customerName || '',
                    "payment_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                    "payment_amount": self.paga_merchant.serviceToPay.servicePrice,
                    "payment_date": new Date().toJSON().slice(0,10).replace(/-/g,'/'),
                    "payment_formatted_token_voucher": formatted_voucher || 0,
                    "payment_merchant_service_purchased_units": '',
                    "payment_merchant_service_purchased_unitType": '',
                    "payment_merchant_service_purchased_units_type" :'1Units', //def default
                }
                self.payment_receipt_details = set_details;
                //../prepare receipt
            }else{
                service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                    if(data.body.responseCode != 0){
                        if(data.body.responseCode == -1){
                            this.data_error_message = "Please review your details, Amount to purchase may be too low";
                            this.disable_btn_wallet = false; //this.disable_btn_wallet = true;
                            this.disable_btn = false; //this.disable_btn = true;
                            this.paga_merchant.serviceToPay.servicePrice = 0;
                        }else if(data.body.responseCode == 38051){
                            this.data_error_message = "Please review your details, the Amount to Purchase does not match";
                        }else{
                            this.data_error_message = "Payment could not be processed. Please review your details";
                            this.disable_btn_wallet = false; //this.disable_btn_wallet = true;
                            this.disable_btn = false; //this.disable_btn = true;
                            //service purchase from paga failed
                            //send mail to admin to reconcile payment
                            this.afterProcessingSendMessage(data.body.responseCode);
                        }
                        // this.show_paga_service_details = true;
                        this.setPayWithOption = false;
                    }
                    else{
                        //some settings
                        let paga_merchant_service_purchased_units = '';
                        let paga_merchant_service_purchased_unitType = '';
                        let paga_merchant_service_purchased_units_type = '';
                        let paga_transaction_token = "";
                        let paga_transaction_total_payment = self.paga_merchant.serviceToPay.servicePrice;
                           
                        //check for some response data payload attributes
                        if(data.body.transactionId && (data.body.transactionId != '' || data.body.transactionId != null)){
                            // console.log("t8889999999999");
                            //UN-DEPRAC:Do not attach here  //MORE IFSs 
                            // self.paga_merchant.serviceToPay.serviceName = self.paga_merchant.serviceToPay.serviceName + "-- Recharge Token: " +data.body.confirmationCode + " .";
                            //self.payment_service_message = "Recharge Token: "+data.body.confirmationCode;
                            // console.log("rrrrrrrr11111");

                            //---setts
                            //-----get token and other required info from paga response payload
                            /*let recharge_token = data.body.confirmationCode;
                            let formatted_voucher = recharge_token.match(/.{1,4}/g).join('-');*/
                            let recharge_token = "";
                            let formatted_voucher = "";
                            //-------some required data
                            if(data.body.additionalProperties && (Object.keys(data.body.additionalProperties).length > 0)){
                                let prp_data = data.body.additionalProperties;
                                recharge_token = prp_data.token;
                                formatted_voucher = recharge_token.match(/.{1,4}/g).join('-');
                                //get the units and unitType
                                if(prp_data.units && (prp_data.units != '')){
                                    paga_merchant_service_purchased_units = prp_data.units;
                                }
                                if(prp_data.unitType && (prp_data.unitType != '')){
                                    paga_merchant_service_purchased_unitType = prp_data.unitType;
                                }
                                paga_merchant_service_purchased_units_type = paga_merchant_service_purchased_units+" "+paga_merchant_service_purchased_unitType;
                                //
                                if(data.body.additionalProperties.token && (data.body.additionalProperties.token != '')){
                                    paga_transaction_token = data.body.additionalProperties.token;
                                }
                                //
                                if(data.body.additionalProperties.totalPayment && (data.body.additionalProperties.totalPayment > 0)){
                                    paga_transaction_total_payment = data.body.additionalProperties.totalPayment;   
                                }
                            }
                            //-------./--some required data
                           
                            //
                            self.payment_service_message = "Recharge Token: "+formatted_voucher;

                            //save frequent data propmpt
                            if(self.save_service_data_prompt){
                                //set_payload
                                var set_payload = {
                                    "merchant": self.paga_merchant.paga_service_group_merchant_id,
                                    "merchant_service_id": self.paga_merchant.serviceToPay.serviceId || 0,
                                    "merchant_number": self.customer.customerCodeAtBiller,
                                    "merchant_number_name": self.customer_received_details.customerName,
                                    "merchant_user": self.user.user_id || 0,
                                }
                                //
                                self.prepSaveServiceData(set_payload); 
                            }
                            //../save frequent data propmpt

                            //prepare receipt
                            var set_details = {
                                "payment_merchant_name": self.paga_merchant.paga_service_group_merchant_displayName,
                                "payment_merchant_logo": self.paga_merchant.paga_service_group_merchant_attached_image,
                                "payment_merchant_service":  self.paga_merchant.serviceToPay.serviceName,
                                "payment_merchant_code_number": self.customer.customerCodeAtBiller,
                                "payment_payer_merchant_name": self.customer_received_details.customerName || '',
                                "payment_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                                "payment_amount": self.paga_merchant.serviceToPay.servicePrice,
                                "payment_date": new Date().toJSON().slice(0,10).replace(/-/g,'/'),
                                "payment_formatted_token_voucher": formatted_voucher || 0,
                                "payment_merchant_service_purchased_units": paga_merchant_service_purchased_units || '',
                                "payment_merchant_service_purchased_unitType": paga_merchant_service_purchased_unitType || '',
                                "payment_merchant_service_purchased_units_type" :paga_merchant_service_purchased_units_type || '',
                            }
                            self.payment_receipt_details = set_details;
                            console.log(7889606333)
                            console.log(set_details)
                            //../prepare receipt
                        }else{
                            // console.log(data.body.confirmationCode)
                        }
                        //../some settings
                        
                        //validate merchant payment
                        //...call paga here if method available
                        //update cn db
                        var payload = {
                            //live params
                            "paga_transaction_message": data.body.message || "Nil",
                            "paga_transaction_confirmationCode": paga_transaction_token || "Nil",
                            "paga_transaction_transactionId": data.body.transactionId || "Nil",
                            "paga_transaction_availableBalance": data.body.availableBalance || 0,
                            "paga_transaction_agentCommission": data.body.commissionEarned || 0,
                            //set for defaulting airtime purchase
                            "paga_transaction_referenceNumber": data.body.referenceNumber || "Nil",
                            "paga_transaction_amount":paga_transaction_total_payment || 0,
                            "paga_transaction_airtime_receiverPhoneNumber": data.body.receiverPhoneNumber || "Nil",
                            //targeted for rewards on successful paga payments
                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_payer_merchant_name": self.customer_received_details.customerName || '',
                            "paga_payer_merchant_address":  'not set',
                            "paga_merchant_service_purchased_units": paga_merchant_service_purchased_units || '',
                            "paga_merchant_service_purchased_unitType": paga_merchant_service_purchased_unitType || '',
                            "payer_logged": self.loggedIn,
                            "payer_user_id": self.user.user_id || 0,
                            "txn_ref": self.cnpay_post_txn_ref,

                            //test params
                            // "paga_transaction_referenceNumber": "Nil",
                            // "paga_transaction_airtime_receiverPhoneNumber":  "Nil",
                            // "paga_transaction_message":  "Nil",
                            // "paga_transaction_confirmationCode": "Nil",
                            // "paga_transaction_transactionId":  "Nil",
                            // "paga_transaction_availableBalance":  0,
                            // "paga_transaction_agentCommission":  0,
                        }
                       
                        service.updateCNpayPagaPaymentNotification(self,self.cnpay_post_txn_id,payload).then(response22 => {
                           self.afterProcessing(0,service.service_payment_circle_fully_successful);
                        }).catch((err) => {
                            // console.log(err)
                            self.afterProcessing(1,service.service_payment_circle_not_fully_successful);
                        })
                        //afterprocess
                       
                        //save frequent data propmpt
                        // if(self.save_service_data_prompt){
                        //     //set_payload
                        //     var set_payload = {
                        //         "merchant": self.paga_merchant.paga_service_group_merchant_id,
                        //         "merchant_service_id": self.paga_merchant.serviceToPay.serviceId || 0,
                        //         "merchant_number": self.customer.customerCodeAtBiller,
                        //         "merchant_number_name": self.customer_received_details.customerName,
                        //         "merchant_user": self.user.user_id || 0,
                        //     }
                        //     //
                        //     self.prepSaveServiceData(set_payload); 
                        // }
                        //../save frequent data propmpt
                    }
                }).catch((err) => {
                    if(err) {
                        ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },

        //updatePagaMerchantServicesPayment() {},

        payPagaPurchaseAirtime() { 
            //reset
            this.payment_service_message = "";
            //let seek_url = 'https://qa1.mypaga.com/paga-webservices/agent-rest/secured/purchaseAirtime';
            let seek_url = service.paga_apiBaseUrl+'airtimePurchase';
            /*if(this.show_data_bundle){
                var payload = {
                    "referenceNumber":this.cnpay_post_txn_ref,
                    "locale": " ", 
                    "receiverPhoneNumber":this.paga_bundle_request.phone_no,
                    "amount":this.paga_bundle_request.servicePrice,
                    "quantity": 1,
                    "message": "", 
                    "identificationType": "", 
                    "identificationNumber": "",
                    "operatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                    "isDataBundle":true,
                    "networkServiceId": this.paga_bundle_request.serviceId,
                }
            }else{
                var payload = {
                    "referenceNumber":this.cnpay_post_txn_ref,
                    "locale": " ", 
                    "receiverPhoneNumber":this.paga_airtime_request.phone_no,
                    "amount":this.paga_airtime_request.amount,
                    "quantity": 1,
                    "message": "", 
                    "identificationType": "", 
                    "identificationNumber": "",
                    "operatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                }
            }*/
            if(this.show_data_bundle){
                var payload = {
                    "referenceNumber":this.cnpay_post_txn_ref,
                    "mobileOperatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                    "mobileOperatorServiceId": this.paga_bundle_request.serviceId,
                    "amount":this.paga_bundle_request.servicePrice,
                    "currency": "NGN", 
                    "locale": "", 
                    "destinationPhoneNumber":this.paga_bundle_request.phone_no,     
                    "isSuppressRecipientMessages": true,     
                    "isDataBundle":true,
                }
            }else{
                var payload = {
                    "referenceNumber":this.cnpay_post_txn_ref,
                    "mobileOperatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                    "amount":this.paga_airtime_request.amount,
                    "currency": "NGN", 
                    "locale": "", 
                    "destinationPhoneNumber":this.paga_airtime_request.phone_no,     
                    "isSuppressRecipientMessages": true,     
                    "isDataBundle":false,
                }
            }
    
        
            let hash = service.SHA512(String(payload.referenceNumber) + String(payload.amount) + payload.destinationPhoneNumber + service.paga_apiKey);
            let set_phone_number = payload.receiverPhoneNumber;
            let self = this;
            
            //test mode
            let test_mode = false;
            if(test_mode){
                console.log("test_mode: chilling here");
                self.payment_service_message = "Voucher: 1111111111111111111111111111111";
                self.afterProcessing(0,service.service_payment_circle_fully_successful);
                //save frequent data propmpt
                if(self.save_service_data_prompt){
                    //set payload
                    var set_payload = {
                        "merchant": self.paga_merchant.paga_service_group_merchant_id,
                        "merchant_service_id": 0,
                        "merchant_number": set_phone_number,
                        "merchant_number_name": "",
                        "merchant_user": self.user.user_id || 0,
                    }
                    self.prepSaveServiceData(set_payload); 
                }
                //../save frequent data propmpt
                //prepare receipt
                var set_details = {
                    payment_merchant_name: self.paga_merchant.paga_service_group_merchant_displayName,
                    payment_merchant_logo: self.paga_service_group_merchant_attached_image,
                    payment_merchant_service: self.paga_merchant.serviceToPay.serviceName,
                    payment_merchant_code_number: set_phone_number,
                    payment_payer_merchant_name: '',
                    payment_payer_merchant_address: '',
                    payment_amount: self.paga_merchant.serviceToPay.servicePrice,
                    payment_date: new Date().toJSON().slice(0,10).replace(/-/g,'/'),//new Date(),
                    payment_formatted_token_voucher: 0,
                }
                self.payment_receipt_details = set_details;
                //../prepare receipt
            }else{
                // service.simulGetPagaRequest(self,payload,seek_url,hash).then(data => {
                service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                    if(data.body.responseCode == 0){
                        //save frequent data propmpt
                        if(self.save_service_data_prompt){
                            //set payload
                            var set_payload = {
                                "merchant": self.paga_merchant.paga_service_group_merchant_id,
                                "merchant_service_id": 0,
                                "merchant_number": set_phone_number,
                                "merchant_number_name": "",
                                "merchant_user": self.user.user_id || 0,
                            }
                            self.prepSaveServiceData(set_payload); 
                        }
                        //../save frequent data propmpt
                        //prepare receipt
                        var set_details = {
                            payment_merchant_name: self.paga_merchant.paga_service_group_merchant_displayName,
                            payment_merchant_logo: self.paga_service_group_merchant_attached_image,
                            payment_merchant_service: self.paga_merchant.serviceToPay.serviceName,
                            payment_merchant_code_number: set_phone_number,
                            payment_payer_merchant_name: '',
                            payment_payer_merchant_address: '',
                            payment_amount: self.paga_merchant.serviceToPay.servicePrice,
                            payment_date: new Date().toJSON().slice(0,10).replace(/-/g,'/'),//new Date(),
                            payment_formatted_token_voucher: 0,
                        }
                        self.payment_receipt_details = set_details;
                        //../prepare receipt
                        //
                        //validate merchant payment
                        //...call paga here if method available
                        //update cn db with purchase airtime details
                        var payload = {
                            //live params
                            "paga_transaction_referenceNumber": data.body.referenceNumber || "Nil",
                            "paga_transaction_amount":self.paga_merchant.serviceToPay.servicePrice || 0,
                            "paga_transaction_airtime_receiverPhoneNumber": data.body.receiverPhoneNumber || "Nil",
                            "paga_transaction_message": data.body.message || "Nil",
                            "paga_transaction_confirmationCode": data.body.token || "Nil",
                            "paga_transaction_transactionId": data.body.transactionId || "Nil",
                            "paga_transaction_availableBalance": data.body.availableBalance || 0,
                            "paga_transaction_agentCommission": data.body.commissionEarned || 0,
                            //targeted for rewards on successful paga payments
                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_payer_merchant_name": self.customer_received_details.customerName || '',
                            "paga_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                            "paga_merchant_service_purchased_units": '',
                            "paga_merchant_service_purchased_unitType": '',
                            "payer_logged": self.loggedIn,
                            "payer_user_id": self.user.user_id || 0,
                            "txn_ref": self.cnpay_post_txn_ref
                            //
                            //test params
                            // "paga_transaction_referenceNumber": "Nil",
                            // "paga_transaction_airtime_receiverPhoneNumber":  "Nil",
                            // "paga_transaction_message":  "Nil",
                            // "paga_transaction_confirmationCode": "Nil",
                            // "paga_transaction_transactionId":  "Nil",
                            // "paga_transaction_availableBalance":  0,
                            // "paga_transaction_agentCommission":  0,
                        }
                        
                        service.updateCNpayPagaPaymentNotification(self,self.cnpay_post_txn_id,payload).then(response22 => {
                            self.afterProcessing(0,service.service_payment_circle_fully_successful);
                        }).catch((err) => {
                            // console.log(err)
                            self.afterProcessing(1,service.service_payment_circle_not_fully_successful);
                        })
                    }else{
                        //service purchase from paga failed
                        self.afterProcessing(1,service.service_purchase_failed);
                        //send mail to admin to reconcile payment
                        self.afterProcessingSendMessage(data.body.responseCode);
                    }
                }).catch((err) => {
                    if(err) {
                        ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })

                //save frequent data propmpt
                // if(self.save_service_data_prompt){
                //     //set payload
                //     var set_payload = {
                //         "merchant": self.paga_merchant.paga_service_group_merchant_id,
                //         "merchant_service_id": 0,
                //         "merchant_number": set_phone_number,
                //         "merchant_number_name": "",
                //         "merchant_user": self.user.user_id || 0,
                //     }
                //     self.prepSaveServiceData(set_payload); 
                // }
                //../save frequent data propmpt
            }
        },

        //updatePagaPurchaseAirtimePayment() {},

        //./PAGA

        //settings
        getServiceSavedData(merchant){
            //get
            let self = this;
            localforage.getItem("saved_services_data", function(err, value) { //quick with the callback version
                if(value != undefined) { 
                    let match = [];
                    for(let row of value){
                        if(row.merchant == merchant){
                            match.push(row);
                        }
                    }
                    self.set_service_saved_data = match;
                }
            }).catch(function(err) {});  
        },

        prepSaveServiceData(payload){
            let can_add = false
            //check if not saved before
            let self = this;
            //
            if((payload.merchant_number != '') && (payload.merchant_number != undefined)){
                localforage.getItem("saved_services_data", function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        let is_added = false;
                        for(let row of value){
                            if((row.merchant == payload.merchant) && (row.merchant_number == payload.merchant_number)){
                                is_added = true;
                            }
                        }
                        if(!is_added){
                            self.saveServiceData(payload);
                        }
                    }else{//empty store //just add
                        self.saveServiceData(payload);
                    }
                });
            } 
        },

        saveServiceData(payload){
            if((payload.merchant_number != '') && (payload.merchant_number != undefined)){
                if(payload.merchant_user > 0){
                    service.saveServiceData(this,payload).then(response => {
                        console.log("saved");
                        //re-update local forage
                        this.setSavedServiceDataLocal(response.body.data,1);
                    }).catch((err) => {
                        console.log(err);
                    })
                }else{
                    //save to local forage
                    this.setSavedServiceDataLocal(payload,2);
                }
            }
        },

        setSavedServiceDataLocal(data,save_type){
            if(Object.keys(data).length > 0){
                if(save_type == 1){//from server
                    // let base_arr = [];
                    // base_arr.push(data);
                    localforage.setItem("saved_services_data", data).then(function (value) {}).catch(function(err) {});
                }else if(save_type == 2){
                    //add to data
                    localforage.getItem("saved_services_data", function(err, value) { //quick with the callback version
                        if(value != undefined) {
                            value.push(data);
                            //reset
                            localforage.setItem("saved_services_data", value).then(function (value) {}).catch(function(err) {});
                        }else{
                            //add-new
                            let base_arr = [];
                            base_arr.push(data);
                            localforage.setItem("saved_services_data", base_arr).then(function (value) {}).catch(function(err) {});
                        }
                    }).catch(function(err) {
                        //add-new
                        let base_arr = [];
                        base_arr.push(data);
                        localforage.setItem("saved_services_data", base_arr).then(function (value) {}).catch(function(err) {});
                    });  
                } 
            }  

        },

        getSavedServiceDataLocal(){
            let self = this;
            localforage.getItem("saved_services_data", function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.saved_services_data = value;
                }
            });          
        },

        getSavedServiceData(){
            if(Object.keys(this.user).length > 0 && (this.user.user_id > 0)){
                service.getSavedServiceData(this,this.user.user_id).then(response => {
                    let data = response.body.data;
                    this.saved_services_data = data;
                    //update local
                    this.setSavedServiceDataLocal(data,1);
                }).catch((err) => {
                    //console.log(err)
                })
            }else{
                this.getSavedServiceDataLocal();
            }
        },
        
        afterProcessing(status,msg){
            ///XXReload -- set this for reload after transaction
            this.transaction_processed_reload = true;
            ///XXReload

            //
            let self = this;
            self.payment_message = msg;
            let save_msg = self.payment_service_message;
            setTimeout(function (){
                if(status == 0){}
                if(status == 1){
                   //log it
                }
                // $('#paywith').modal("hide"); //let user close
                // self.reset(); //deactivate here for now CASE:X01
                //recheck
                // self.payment_message = msg;
                // self.payment_service_message = save_msg;
            }, 10000);
            // self.preset(); // use for reloading for now
        },

        afterProcessingSendMessage(error_code){
            let self = this;
            //post error message
            let service_merchant_name = self.paga_service_group_merchant_displayName || self.paga_service_group_mobile_operatorName || '';
            let service_merchant_service_name = self.paga_merchant.serviceToPay.serviceName;
            let service_merchant_service_price = self.paga_merchant.serviceToPay.servicePrice;
            let service_cnpay_post_pay_txn_ref = self.cnpay_post_txn_ref;
            var msg = {
                "message_from":"Service Purchase From PAGA Failed",
                "message_body": "Service Purchase Details "+service_merchant_name+" - "+service_merchant_service_name+" Amount: "+service_merchant_service_price+" Ref: "+service_cnpay_post_pay_txn_ref+" Buyer Email: "+self.customer.customerEmail+" PAGA Response Code: "+error_code+". Please reconcile" 
            }
            service.postMessages(this,msg).then(data => {});
        },

        getCNpayCharges(){
            service.getCNpayCharges(this).then(response => {
                this.range_1_max = response.body.r1max;
                this.range_2_max = response.body.r2max;
                this.range_1_pay = response.body.r1pay;
                this.range_2_pay = response.body.r2pay;
                this.range_3_pay = response.body.r3pay;
                this.ravecomm = (response.body.ravecomm / 100);
            }).catch((err) => {
                 //console.log(err)
            })
        },

        //wallet calls
        getWalletBalance() {
            let user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletBalance(this,user_id).then(data => {
                if(data.body.status == 200) {
                    this.current_wallet_balance = data.body.data_current_wallet_balance;
                    localStorage.setItem("cityneeds_wb", this.current_wallet_balance);
                    this.headerKey++;
                }
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },

        formatCurrency_2(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            currency =  currency.replace(".00", ""); //strip off NGN
            return currency;
        },


        //....wallet calls

        login() {
            this.disable_btn_login = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password,
            }
            let navi = this.$router;
            if(credentials.user_email == null || credentials.user_email == undefined || credentials.user_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.user_password == null || credentials.user_password == undefined || credentials.user_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
               service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            localStorage.setItem("cityneeds_user", element.user_fullname);
                            localStorage.setItem("cityneeds_token", element.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("cityneeds_token_key", element.user_token_key); 
                        }, this);
                        //ok get wallet balance
                        this.getWalletBalance();
                        this.loggedIn = true;
                        
                        
                        //close modal
                        $('#login').modal("hide");

                        //reload..cos of some issues
                        // location.reload();
                        //use this for now
                        this.preset();
                       
                        
                    }else{
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn_login = false;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn_login = false;
                        this.disable_btn = false;
                    }else{
                        toastr.error("Please Re-try Once More", 'Warning!');
                        //log it //console.log(err)
                        this.disable_btn_login = false;
                        this.disable_btn = false;
                    }
                })
            }
        },

        preset() {
            this.headerKey++;
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                                this.user.user_id = element.user_id;
                                this.loggedIn = true;
                                this.getWalletBalance();
                                //get saved data
                                this.getSavedServiceData();
        
                                //get user's full details
                                service.getUser(this, element.user_id).then(data => {
                                    if(data.body.status == 200) {
                                        this.user_details = data.body.data;
                                        this.setCustomerDetails();
                                    }
                                }).catch((err) => {
                                    if(err) {
                                       //log me
                                    }
                                })
                                
                        // this.getUsersDetails()
                        }, this);
                    }else {
                       // this.$router.push('login');
                       
                       //remove wallet balance from storage
                        localStorage.removeItem("cityneeds_wb");
                    }
                }).catch((err) => {
                    if(err) {
                       // this.$router.push('login');
                    }
                })
            }else {
               // this.$router.push('login');
            }
                
        },

        setCustomerDetails(){
            if(this.loggedIn){
                this.customer.customerName = this.user_details.user_fullname; //for sync process
                this.customer.customerFirstName = this.user_details.user_fullname.split(" ")[0];
                this.customer.customerLastName = this.user_details.user_fullname.split(" ")[1] || "";
                this.customer.customerEmail = this.user_details.user_email;
                this.customer.customerPhoneNumber = this.user_details.user_phone;
                // this.customer.customerPhoneNumber = this.user.user_phone;
            }
            if(!this.customer.customerCodeAtBiller){this.customer.customerCodeAtBiller = '';}
        },
        
        //wallet calls
        promptTopUpWallet(){
            $("#topup").modal();
        },

        //get wallet processing charges
        getWalletProcessingCharges() {
            service.getWalletProcessingChargesRF(this).then(data => { //Using RF for now
                this.wallet_charges = data.body.data;
                this.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount; //already set min balance
                this.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount; //already set min balance
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getWalletTransactions() {
            let user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletTransactions(this,user_id).then(data => {
                 if(data.body.status == 200) {
                     this.current_wallet_balance = data.body.data_current_wallet_balance;
                     localStorage.setItem("cityneeds_wb", this.current_wallet_balance);
                 }
                 this.wallet_transactions = data.body.data;
                 this.loading = false;
             }).catch((err) => {
                 if(err) {
                     ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
        },

        prepareWalletPayment(){
            if(this.wallet_transaction.topay_amt == null){
                toastr.error('Amount is empty', 'Warning!');
            }else{
                this.wallet_transaction.topay_amt = parseFloat(this.wallet_transaction.topay_amt); //casting
            
                if(this.wallet_transaction.topay_amt > this.max_wallet_topup_amount){
                    this.wallet_payment_error_message = 'Maximum Topup amount exceeded';
                    toastr.error('Maximum Topup amount exceeded', 'Warning!');
                }
                else if(this.wallet_transaction.topay_amt < this.min_wallet_topup_amount){
                    this.wallet_payment_error_message = 'Minimum Topup amount is 100NGN';
                    toastr.error('Minimum Topup amount is 100', 'Warning!');
                }
                else{
                    //check for matching processing fee
                    this.wallet_charges.forEach(function(element) {
                        if((this.wallet_transaction.topay_amt >= element.wallet_charge_min) && (this.wallet_transaction.topay_amt <= element.wallet_charge_max)){
                            this.wallet_transaction.processing_fee = element.wallet_charge_charge;
                        }
                    }, this);
                    this.wallet_payment_calculated = true;
                }
            }
        },

        makePayment(){
            this.disable_topup_wallet_btn = true;
           let user_id = localStorage.getItem("cityneeds_token_key");
           var payload = {
               "user": user_id,
               "service": 2, //wallet top-up
            }
           service.setUserPaymentDetails(this,payload).then(data => {
                this.payment_details = data.body.data;
                //then process payment
                this.processWalletPayment();
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
       
        processWalletPayment() {
            let self = this;
            var x = getpaidSetup({
               // PBFPubKey: "FLWPUBK-7bfea41df783f28ad7c71d9925a1bc57-X", //api public key//live
                PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X", //test
                customer_email: self.payment_details.payer_email, // "mail@gmail.com"
                amount: (self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee),
                customer_phone: self.payment_details.payer_phone, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                txref: "CNwallet-"+self.payment_details.payer_txn_ref,
                meta: [{
                    metaname: "CNwallet",
                    metavalue: self.payment_details.payer_name
                }],
                onclose: function() {},
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.processing = true;
                        
                        // redirect to a success page
                       // console.log("good to go!"+txref)

                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                        //     // console.log(response); // 42
                        //     // console.log(response.body.data.status); // 42
                        //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                        //         //check if the amount is same as amount you wanted to charge just to be very sure
                        //         self.payment_message = "Payment processed successfully, check your email for your receipts."
                                
                        //         if (response.body.data.amount === tx_amount) {
                        //             //enter into db
                                    

                                    let txn_payload={
                                        "txn_ref": txref,
                                        "pay": self.user.user_id,
                                        "txn_amount": self.wallet_transaction.topay_amt,
                                        "processing_fee": self.wallet_transaction.processing_fee,
                                        "topup_by_admin": 0,
                                        "total_amount": tx_amount
                                    };
                                    //post payment
                                    service.postWalletTopup(self,txn_payload).then(response => {
                                        //success message
                                        self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                                        self.loading = true;
                                        self.disable_topup_wallet_btn = false;
                                        setTimeout(function (){
                        
                                            self.closeModal('#topup');
                                          
                                          }, 4000);
                                        
                                        //this get wallet transaction
                                        self.getWalletTransactions();
                                        
                                    }).catch((err) => {
                                        //console.log(err)
                                    })
                            //     }
                            // }
                           
                            
                        // }).catch((err) => {
                        //     //console.log(34545)
                        //    // console.log(err)
                        // })
                        //...//....server validation
                    } else {
                        // redirect to a failure page.
                        //console.log("bad to go!"+txref)
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
    
                    x.close(); // use this to close the modal immediately after payment.
                }
            });
        },

        //./wallet calls

        getPagaAccountBalance(){
            let seek_url = service.paga_apiBaseUrl+"accountBalance";
            var payload = {
                "referenceNumber":new Date().getTime(),
                "locale": " "
            }
           
            let hash = service.SHA512(String(payload.referenceNumber) +  service.paga_apiKey);
            
           
            let self = this;
            service.getPagaRequest(self,payload,seek_url,hash).then(data => {
                if(data.body.responseCode == 0){
                   
                }
            }).catch((err) => {})
        },

        //
        getDefaultRandomNumbers(){
            return Math.floor(100000000 + Math.random() * 900000000); //9 digit non-zero leading number
        },

        //
        deleteSaved(index){},

        //
        printDiv(divId,title) {

            let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

            mywindow.document.write(`<html><head><title>${title}</title>`);
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            return true;
        },

        saveDiv(divId, title) {
            this.downloading = true;
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width; 
            var HTML_Height = d_position.height; 
            
            var element = document.getElementById(divId);
            var opt = {
                margin:   1,//[-3, 1, 2, 1],// 1,
                filename: title+'.pdf',
                image:    { type: 'jpeg', quality: 0.98 },
                html2canvas: { allowTaint:true, useCORS:true, scale: 2},
                // jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                //jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
                jsPDF: { unit: 'mm', format: [312, 592], orientation: 'portrait' }
            };
            
            // New Promise-based usage:
            // html2pdf().set(opt).from(element).save();
            //--to check for output time
            let self = this;
            html2pdf().set(opt).from(element).save().then(function () {
                //
                console.log('saving');
                setTimeout(function (){
                    self.downloading = false;
                }, 2500);
            });
            //  var d_divId = document.getElementById(divId);

            //--downloading
            // let self = this;
            // setTimeout(function (){
            //     self.downloading = false;
            // }, 10000);
            //../downloading
        },
    },

    created: function(){
        this.reset();
        this.getPagaMerchants();
        //check if a login request in url
        if(this.$route.query.login == 'login'){
            setTimeout(function (){
                $('#login').modal();
                //change url without reloading page
                window.history.pushState(null, null, '/');
             }, 500);
        }else{
            //ok continue
            if(localStorage.getItem("cityneeds_token_key") != undefined){
                this.preset();
            }
            else{
                this.login_script = true;
                setTimeout(function (){
                   $('#login').modal();
                   // self.closeModal('#topup');
                
                }, 4000);
            }
        }

        
        //more
        this.getCNpayCharges();
        this.getPagaServiceGroups();
        

        //wallet
        this.getWalletProcessingCharges();
        
        this.getPagaAccountBalance();
      
    }

}


// WEBPACK FOOTER //
// ./src/components/CNpay/script.js